// debounce function
// https://dev.to/bwca/create-a-debounce-function-from-scratch-in-typescript-560m
export function debounce(fn, ms) {
    let timer;
    const debouncedFunc = (args) => new Promise((resolve) => {
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            resolve(fn(args));
        }, ms);
    });
    const teardown = () => clearTimeout(timer);
    return [debouncedFunc, teardown];
}
/**
 * By default, getPropertyValue will include the quotes in a string. This utility trims them off.
 * @param element
 * @param prop
 * @returns
 */
export function getCssProperty(element, prop) {
    let value = getComputedStyle(element).getPropertyValue(prop).trim() || null;
    if ((value?.startsWith("'") && value.endsWith("'")) || (value?.startsWith('"') && value.endsWith('"'))) {
        value = value.slice(1, -1);
    }
    return value;
}
/**
 * @param element The LitElement to set the CSS custom property on
 * @param prop CSS custom property (variable) to set
 * @param val The value to set the custom property to
 * @param defaultVal Optional default value (prefer doing this in your CSS instad of here)
 * @returns void/undefined
 */
export function maybeSetCssProperty(element, prop, val, defaultVal = null) {
    val = val?.trim();
    if (!val && !defaultVal) {
        return;
    }
    if (!val && defaultVal) {
        val = defaultVal;
    }
    // the if statements above guarantee that val is truthy
    const value = val.startsWith('--') ? `var(${val})` : val;
    element.style.setProperty(prop, value);
}
// https://github.com/martinstark/throttle-ts/blob/main/src/index.ts
export const throttle = (fn, delay) => {
    let wait = false;
    let timeout;
    let cancelled = false;
    function resetWait() {
        wait = false;
    }
    return [
        (...args) => {
            if (cancelled)
                return undefined;
            if (wait)
                return undefined;
            const val = fn(...args);
            wait = true;
            timeout = window.setTimeout(resetWait, delay);
            return val;
        },
        () => {
            cancelled = true;
            clearTimeout(timeout);
        },
        () => {
            clearTimeout(timeout);
            resetWait();
        }
    ];
};
